import React from "react";
import history from "../../../../history";
import { useCommonContext } from "../../../context/common-context";
import CaretDefault from "../../icons/caret-default.svg";

const setCookie = (name, value) =>
  (document.cookie = `${name}=${value}; path=/`);

const SubmitRequest = ({ category }) => {
  const { isGuest } = useCommonContext();

  const handleClick = React.useCallback(
    (href) => {
      if (category.link && category.link.defaultUrl) {
        if (isGuest) {
          setCookie(
            "ECommRedirectURL",
            encodeURIComponent(
              `${window.location.origin}${category.link.defaultUrl}`
            )
          );
        }
      }
      if (href) {
        window.location.href = href;
      }
    },
    [isGuest, category]
  );

  return (
    <div className="col-md-4 my-3">
      <a
        onClick={() => handleClick(category.link.href)}
        href="javascript:void(0)"
      >
        <div className="card h-100 no-border">
          <div className="w-100 text-center icon">
            <img className="p-2" src={category.image} />
          </div>
          <div className="card-body text-center pb-0 main-countainer">
            <h4 className="font-weight-bold main-title">{category.title}</h4>
            <h5 className="font-weight-normal px-md-2 submit-desc">
              {category.desc}
            </h5>
            <div className=" py-0 text-center">
              {category.link && category.link.label && (
                <h4 className="btn font-weight-bold homepage-nav link m-auto">
                  {" "}
                  {category.link.label}{" "}
                  <img className="ml-2" src={CaretDefault} />
                </h4>
              )}
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default SubmitRequest;
